export type EntityName =
  | "users"
  | "deals"
  | "people"
  | "companies"
  | "leads"
  | "contracts"
  | "partners"
  | "partners_contacts";

export const ENTITY_NAME_TO_PREFIX: Record<EntityName, string> = {
  users: "u-",
  deals: "d-",
  people: "p-",
  companies: "c-",
  leads: "l-",
  contracts: "con-",
  partners: "ptn-",
  partners_contacts: "ptc-",
};
